import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import type { Href } from 'expo-router';

import { ROUTES } from '@/constants/routes';

/**
 * Where to open the general composer over the screen the reader is on, so that screen stays
 * beneath it with a way back.
 *
 * On native every link to the composer's usual path opens the Inquiry tab, which is a top-level
 * page with no back button. Opened from a pushed screen such as a chat, that would cover it with a
 * second copy of the tabs and no visible way back, so native takes the composer's stacked route.
 * Web has no tab bar and keeps the composer in the browser's history either way.
 */
export function getStackedInquiryHref(params?: Record<string, string>): Href {
  const pathname = isWeb ? ROUTES.INQUIRY : ROUTES.INQUIRY_STACKED;

  const query = params ? new URLSearchParams(params).toString() : '';

  return (query ? `${pathname}?${query}` : pathname) as Href;
}
